
import React, { PureComponent } from "react";
import styles from "./StaticPage.scss";
import { searchToObject } from "../../utils";
import ClanBattlesRulesPage from "../ViewClanBattles/ClanBattlesRulesPage/ClanBattlesRulesPage";

import { Shadows } from "@wg/wows-react-uikit";
export type PureComponent_Props = {};
export type PureComponent_State = {};

const PAGE_TYPES = {
  CLAN_BATTLES: 'clan-battles'
};

class StaticPage extends PureComponent<PureComponent_Props, PureComponent_State> {


  renderPage = () => {
    const searchParams = searchToObject();

    switch (searchParams.page) {
      case PAGE_TYPES.CLAN_BATTLES:
        {
          return <ClanBattlesRulesPage />;
        }

      default:
        {
          return <div></div>;
        }

    }

  };

  render() {
    return <Shadows>
                {this.renderPage()}
            </Shadows>;
  }
}

export default StaticPage;